import React, { useRef } from "react";
import styled from "styled-components";
import { useLanguage } from "../../../Context/LanguageContext";
import { useTheme } from "../../../Context/ThemeContext";
import { lightTheme, darkTheme } from "../../../Styles/theme";
import { ReactComponent as DeleteSvgIcon } from '../../../image/Delete.svg';

export default function ProductBox(props) {
  const { data, onClickProduct, onClickProductDelete } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const DeleteRef = useRef();

  // 물품 클릭시 //
  function onClickProductButton(e) {
    if (DeleteRef.current.contains(e.target)) return;

    onClickProduct(data);
  }

  // 물품 삭제 버튼 클릭시 //
  function onClickProductDeleteButton() {
    onClickProductDelete(data);
  }

  return (
    <ProductBoxView onClick={onClickProductButton}>
      <DeleteButtonWrapper onClick={onClickProductDeleteButton}>
        <DeleteButton ref={DeleteRef}>
          <StyledDeleteIcon />
        </DeleteButton>
      </DeleteButtonWrapper>
      <ProductImageWrapper>
        <ProductImage isEmpty={data.picture === ''} src={data.picture === '' ? 'https://picture.link-zone.org/DefaultLogo.png' : data.picture}/>
      </ProductImageWrapper>
      <ProductInfoBox>
        <ProductInfoWrapper>
          <ProductTextWrapper width={65} alignItems='flex-start'>
            <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} ellipsis>{data.name}</Text>
          </ProductTextWrapper>
          <ProductTextWrapper width={30} alignItems='flex-end'>
            <Text fontFamily='NotoSansKR-Medium' fontSize={15} color={theme.text}>{data.inventory.toLocaleString('ko-KR')}{t('settingProduct.inventoryUnit')}</Text>
          </ProductTextWrapper>
        </ProductInfoWrapper>
        <ProductInfoWrapper>
          <ProductTextWrapper width={35} alignItems='flex-start'>
            <Text fontFamily='NotoSansKR-Regular' fontSize={15} color={theme.text}>{t('settingProduct.priceLabel')}</Text>
          </ProductTextWrapper>
          <ProductTextWrapper width={60} alignItems='flex-end'>
            <Text fontFamily='NotoSansKR-Medium' fontSize={15} color={theme.text}>{data.price.toLocaleString('ko-KR')}{t('settingProduct.currencyUnit')}</Text>
          </ProductTextWrapper>
        </ProductInfoWrapper>
      </ProductInfoBox>
    </ProductBoxView>
  )
}

const ProductBoxView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 190px;

  box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.10);
  border-radius: 10px;
  background-color: #44b23e;

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteButtonWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 37px;
  height: 37px;

  border-radius: 0px 10px 0px 10px;
  background-color: ${props => props.theme.pointRedAlpha50};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      background-color: ${props => props.theme.pointRed};
      cursor: pointer;
    }
  }
`;

const StyledDeleteIcon = styled(DeleteSvgIcon)`
  width: 20px;
  height: 20px;
  color: white;
`;

const ProductImageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 190px;
  height: 190px;

  overflow: hidden;

  border-radius: 10px 10px 0px 0px;
`;

const ProductImage = styled.img`
  width: 100%;
  height: 100%;

  object-fit: cover;
  object-position: center;
`;

const ProductInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 78px;

  gap: 10px;

  border-radius: 0px 0px 10px 10px;
  background-color: ${props => props.theme.subBackground};
`;

const ProductInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 86.36%;
  height: 25px;
`;

const ProductTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  // justify-content: center;
  justify-content: flex-start;
  align-items: ${props => props.alignItems};

  width: ${props => props.width}%;
  height: 100%;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  ${props => props.ellipsis && `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  `}
`;